/**
 * Page header stagger sequence.
 *
 * Drives the "staggered load" pattern used by Linear / Notion / Figma so a
 * page's header, description, filters, and content cascade in instead of
 * appearing all at once. Each {@link StaggerItem} is offset from the previous
 * by this single step, keeping every page on the exact same rhythm:
 *
 *   index 0 → Header       (0ms)
 *   index 1 → Description  (100ms)
 *   index 2 → Filters      (200ms)
 *   index 3 → Content      (300ms)
 *
 * Centralizing the step here is the whole point of the primitive — pages pass
 * a semantic `index`, never a hand-typed delay, so the cadence can never drift.
 * The 100ms step matches the original Projects-page header→toolbar rhythm.
 */
export const STAGGER_STEP_SECONDS = 0.1;
